module.exports = __webpack_public_path__ + "img/picture_news_05.8bd92139.png";